import { render, staticRenderFns } from "./Visa.vue?vue&type=template&id=051f3525&scoped=true&"
import script from "./Visa.vue?vue&type=script&lang=js&"
export * from "./Visa.vue?vue&type=script&lang=js&"
import style0 from "./Visa.vue?vue&type=style&index=0&id=051f3525&scoped=true&lang=css&"
import style1 from "./Visa.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f3525",
  null
  
)

export default component.exports